import { enterClickTask } from '@execonline-inc/execonline-ui';
import { toTask } from '@execonline-inc/maybe-adapter';
import { always, noop } from '@kofno/piper';
import { fromEmpty } from 'maybeasy';
import { ChangeEvent } from 'react';
import { Task } from 'taskarian';
import { fromNullableT } from '../../../TaskExt';
import { chatStore } from '../ChatStores/ChatStore';
import { SubmittableStates } from '../ChatStores/ChatStore/Types';

const ChatHandlers = (textareaRef: React.RefObject<HTMLTextAreaElement | null>) => {
  const handleSubmit = (submittable: SubmittableStates) => (e: React.SyntheticEvent) => {
    e.preventDefault();
    toTask({}, fromEmpty(submittable.nextMessage)).fork(noop, (_) => chatStore.sendMessage());
  };

  const handleInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    fromNullableT(textareaRef.current).fork(noop, (el) => {
      el.style.height = 'auto';
      el.style.height = `${Math.min(el.scrollHeight, 80)}px`;
    });
    chatStore.updateNextMessage(e.target.value);
  };

  const el = (e: React.KeyboardEvent<HTMLTextAreaElement>): Task<string, HTMLTextAreaElement> =>
    enterClickTask(e.key).andThen(
      always(fromNullableT(textareaRef.current).mapError(always('textareaRef null'))),
    );

  const handleKeyDown =
    (submittable: SubmittableStates) => (e: React.KeyboardEvent<HTMLTextAreaElement>) =>
      Task.succeed<{}, {}>({})
        .assign('el', el(e))
        .assign('message', toTask({}, fromEmpty(submittable.nextMessage)))
        .map(({ el }) => {
          el.style.height = 'auto';
          e.preventDefault();
          chatStore.sendMessage();
        })
        .fork(noop, noop);

  return { handleSubmit, handleInputChange, handleKeyDown };
};

export default ChatHandlers;
